/**
 * CP (Commonplace) Page - Main entry point for the /cp route
 *
 * Chat + Cards interface for knowledge management with card ingestion.
 */

import { CpView } from './CpView'

export function CpPage() {
  return <CpView />
}
